export const useValidation = () => {
    /**
     * @param { object } v Validator Object from Vuelidate
     * @return { bool } form inputs' validity
     * */
    function isValid(v) {
        v.$touch()

        return !v.$invalid
    }

    return {
        isValid
    }
}
